import { Box, Button, Typography } from '@mui/material'
import { AppContainer } from '@shared/components/AppContainer';
import { useEffect, useState } from 'react';
import { Link as RouterLink, Redirect, useHistory, useLocation, useParams } from 'react-router-dom';

import { TokenOverview } from '@shared/components/TokenOverview';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getMyTokensAction, getTokenAction, resetToken, tokenSelector } from '@store/slices/token.slice';
import { tokenService } from '@services/token.service';
import {appUserProfileSelector, getProfileAction} from '@store/slices/app.slice';
import GatingDialog from "@shared/components/GatingDialog";
import { useQuery } from "@shared/helpers/global.helper";

export const CustomerToken = () => {
    let query = useQuery();
    const history = useHistory();
    const tokenDetails = useAppSelector(tokenSelector);
    const [gatingModalOpen, setGatingModalOpen] = useState(false)
    const dispatch = useAppDispatch();
    let { id } = useParams<{ id: string }>();
    const userProfile = useAppSelector(appUserProfileSelector);
    // const [dataLoaded, setDataLoaded] = useState(false)

    const createTokenActivation = async (id: string) => {
        const response = await tokenService.createActivation(id);
        history.push(`/tokens/${response?.data?.data?.id}/scan`)
    }

    useEffect(() => {
        dispatch(resetToken())
        if (id) {
            dispatch(getTokenAction(id))
        }

        // console.log(tokenDetails);
    }, [])

    return (
        <AppContainer>
            <TokenOverview token={tokenDetails.token}>
                {/* This is probably what's causing the weird redirect */}
                {/*{console.log("User Profile ID: ", userProfile.id)}*/}
                {/*{console.log("Token owner: ", tokenDetails?.token?.owner?.id)}*/}
                {query.get('owned') === 'true' && tokenDetails?.token?.owner?.id === userProfile?.id ? (
                    <>
                        {/*<Box display="flex" sx={{flexDirection: {md: 'column', xs: 'row'}}}>*/}

                        <Box mb={2}>

                            {(tokenDetails?.token?.owner_info?.status !== 'EXPIRED' && tokenDetails?.token?.profile?.status === 'ACTIVE') && (
                                <Button variant="contained" className="w-100" size="large" color="primary"
                                    onClick={() => createTokenActivation(tokenDetails.token.id)}>
                                    Membership Card
                                </Button>
                            )}

                            {(tokenDetails?.token?.owner_info?.status === 'EXPIRED' && tokenDetails?.token?.profile?.status === 'ACTIVE') && (
                                <Button variant="contained" className="w-100" size="large" color="primary"
                                    component={RouterLink} to={`/tokens/${tokenDetails?.token?.id}/buy?renew=true`}>
                                    Renew Membership
                                </Button>
                            )}
                            {/*</Box>*/}
                            {/*(tokenDetails?.token?.owner_info?.status === 'PENDING' && tokenDetails?.token?.profile?.status === 'ACTIVE') && (
                                    <Button disabled={true} variant="contained" className="w-100" size="large" color="primary">
                                        Pending Transaction
                                    </Button>
                                )*/}
                        </Box>
                        {/*<Box display="flex" sx={{flexDirection: {md: 'column', xs: 'row'}}}>*/}


                        {(tokenDetails?.token.profile?.gate?.length !== 0) && (
                            <Box mb={2}>
                                <Button disabled={tokenDetails?.token?.owner_info?.status !== 'ACTIVE'} variant="contained" className="w-100" size="large" color="primary"
                                        onClick={() => setGatingModalOpen(true)}>
                                    {/*<Typography fontWeight={700} className={'button-label'}>*/}
                                    Make Reservation
                                    {/*</Typography>*/}
                                </Button>
                            </Box>
                        )}
                        {/*<GatingDialog open={gatingModalOpen} onClose={() => setGatingModalOpen(false)} tableValue={openTableURL} redirectValue={openRedirectURL} />*/}
                        <GatingDialog open={gatingModalOpen} onClose={() => setGatingModalOpen(false)} gates={tokenDetails?.token.profile?.gate} />

                        {/*<Box mb={3}>
                            <Button disabled={true} variant="contained" className="w-100" size="large"
                                    color="primary"
                                    href={"#"}>View on OpenSea</Button>
                        </Box>*/}


                        {/*</Box>*/}
                    </>
                ) :
                    (
                        <>
                        {/*    TODO: FIX THE REASON FOR THIS */}
                        {/*<Redirect to={{ pathname: `/tokens/${id}` }} />*/}
                        {/*{console.log("REDIRECT")}*/}
                        </>
                    )
                }
            </TokenOverview>
        </AppContainer>
    )
}
